module.exports = __webpack_public_path__ + "static/media/sap_icon.7870c4c6.svg";